import React from 'react'
import { Button } from 'components/ui/Button'
import useLocaleText from 'components/useLocaleText'
import { Trash2 } from 'lucide-react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'

interface IClearContentButtonProps {
  onClick: () => void
  top?: string | number
}

export const ClearContentButton: React.FC<IClearContentButtonProps> = ({ onClick, top = '20px' }) => {
  const isRtl = useSelector(isRtlSelector)
  const label = useLocaleText('clear')

  return (
    <Button
      type="button"
      variant="icon"
      aria-label={label}
      onClick={onClick}
      alignItems="center"
      justifyContent="center"
      borderRadius="full"
      bg="white"
      p={0}
      minW="30px"
      w="30px"
      h="30px"
      pos="absolute"
      right={isRtl ? 'unset' : '20px'}
      left={isRtl ? '20px' : 'unset'}
      style={{
        zIndex: 2,
        top: typeof top === 'number' ? `${top}px` : top,
      }}
    >
      <Trash2 color="#dc2626" size={18} />
    </Button>
  )
}
